import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { CATEGORIES } from "../data/ideas";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", topic: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Compila nome, email e messaggio.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/proposals`, form);
      toast.success("Grazie! La tua proposta è stata inviata.");
      setForm({ name: "", email: "", topic: "", message: "" });
    } catch (err) {
      toast.error("Qualcosa è andato storto. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b-2 border-[#0a0d14]/20 py-3 text-lg md:text-xl font-medium text-[#0a0d14] placeholder:text-[#0a0d14]/35 focus:outline-none focus:border-[#d9381e] transition-colors";

  return (
    <section id="partecipa" data-testid="contact-section" className="py-20 md:py-28">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <span className="flex items-center gap-3 mb-4">
            <span className="h-2 w-2 bg-[#d9381e]" />
            <span className="font-mono-num uppercase text-xs tracking-[0.25em] text-[#0a0d14]/60">
              101ª Idea
            </span>
          </span>
          <h2 className="font-display font-black uppercase text-[#0a0d14] tracking-tighter text-5xl md:text-6xl leading-[0.85]">
            La prossima idea
            <br />
            <span className="text-[#0d2c54]">è la tua.</span>
          </h2>
          <p className="mt-6 text-[#0a0d14]/70 leading-relaxed max-w-md font-medium">
            Verona si costruisce insieme. Raccontaci la tua proposta, una
            segnalazione o un problema del tuo quartiere: ogni voce conta.
          </p>
        </div>

        <div className="lg:col-span-7">
          <form onSubmit={submit} data-testid="contact-form" className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <label className="font-mono-num uppercase text-[11px] tracking-widest text-[#0a0d14]/50">
                  Nome e cognome
                </label>
                <input
                  data-testid="input-name"
                  value={form.name}
                  onChange={update("name")}
                  placeholder="Mario Rossi"
                  className={inputCls}
                />
              </div>
              <div>
                <label className="font-mono-num uppercase text-[11px] tracking-widest text-[#0a0d14]/50">
                  Email
                </label>
                <input
                  data-testid="input-email"
                  type="email"
                  value={form.email}
                  onChange={update("email")}
                  placeholder="mario@email.it"
                  className={inputCls}
                />
              </div>
            </div>

            <div>
              <label className="font-mono-num uppercase text-[11px] tracking-widest text-[#0a0d14]/50">
                Tema (facoltativo)
              </label>
              <select
                data-testid="input-topic"
                value={form.topic}
                onChange={update("topic")}
                className={`${inputCls} cursor-pointer`}
              >
                <option value="">Seleziona un tema…</option>
                {CATEGORIES.map((c) => (
                  <option key={c.key} value={c.label}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="font-mono-num uppercase text-[11px] tracking-widest text-[#0a0d14]/50">
                La tua idea o segnalazione
              </label>
              <textarea
                data-testid="input-message"
                value={form.message}
                onChange={update("message")}
                rows={4}
                placeholder="Scrivi qui la tua proposta per Verona…"
                className={`${inputCls} resize-none`}
              />
            </div>

            <motion.button
              whileTap={{ scale: 0.99 }}
              data-testid="submit-proposal-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-[#0d2c54] text-white py-5 font-display font-bold uppercase tracking-wide text-lg md:text-xl hover:bg-[#d9381e] transition-colors disabled:opacity-60"
            >
              {loading ? "Invio in corso…" : "Invia la tua proposta →"}
            </motion.button>
          </form>
        </div>
      </div>
    </section>
  );
}
